// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1YzD3","title":"Images45_title__19Nad","images":"Images45_images__2pe5P"};